import { render, staticRenderFns } from "./Meal.vue?vue&type=template&id=7d86f45e&scoped=true&"
import script from "./Meal.vue?vue&type=script&lang=js&"
export * from "./Meal.vue?vue&type=script&lang=js&"
import style0 from "./Meal.scss?vue&type=style&index=0&id=7d86f45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d86f45e",
  null
  
)

export default component.exports